import { BiPrinter } from "react-icons/bi";
import { CgFileDocument, CgProfile } from "react-icons/cg";
import {
  FaChartBar,
  FaRegHospital,
  FaListUl,
  FaRegFolderOpen,
  FaRegBuilding,
} from "react-icons/fa";
import { FiPieChart, FiUsers } from "react-icons/fi";
import { GrTestDesktop, GrLocation } from "react-icons/gr";
import {
  LuTags,
  LuScreenShare,
  LuMicroscope,
  LuCalendarCheck,
  LuArchive,
  LuArchiveRestore,
  LuFolderCheck,
} from "react-icons/lu";
import {
  MdOutlineCalendarMonth,
  MdDynamicFeed,
  MdContentPasteSearch,
  MdLogout,
  MdOutlineMedicalServices,
} from "react-icons/md";
import { PiGear, PiPillBold, PiBarcodeBold } from "react-icons/pi";
import { RiMessage2Line } from "react-icons/ri";
import { TbBell, TbBed, TbDatabaseDollar } from "react-icons/tb";
import { Permission } from "./allTypes";
import { HiOutlineDocumentAdd, HiOutlineDocumentSearch } from "react-icons/hi";

export const allPermissions: Record<
  Permission,
  {
    id: Permission;
    name: string;
    description: string;
    icon?: any;
    href?: string;
    type: "page" | "action" | "view";
  }
> = {
  dashboardPage: {
    id: "dashboardPage",
    name: "Dashboard",
    description: "",
    icon: <FiPieChart size={18} />,
    href: "/dashboard",
    type: "page",
  },

  adminDashboardPage: {
    id: "adminDashboardPage",
    name: "Dashboard (superadmin)",
    description: "",
    icon: <FiPieChart size={18} />,
    href: "/adminDashboard",
    type: "page",
  },

  statisticsPage: {
    id: "statisticsPage",
    name: "Statistiques",
    description: "",
    icon: <FaChartBar size={16} />,
    href: "/statistics",
    type: "page",
  },

  mysteryPage: {
    id: "mysteryPage",
    name: "Enquête",
    description: "",
    icon: <FaChartBar size={16} />,
    href: "/mystery",
    type: "page",
  },

  usersPage: {
    id: "usersPage",
    name: "Utilisateurs",
    description: "",
    icon: <FiUsers size={18} />,
    href: "/admin/users",
    type: "page",
  },

  admissionsPage: {
    id: "admissionsPage",
    name: "Admissions",
    description: "",
    icon: <FiUsers size={18} />,
    href: "/admissions",
    type: "page",
  },

  rolesPage: {
    id: "rolesPage",
    name: "Roles",
    description: "",
    icon: <LuTags size={18} />,
    href: "/admin/roles",
    type: "page",
  },

  structuresPage: {
    id: "structuresPage",
    name: "Structures",
    description: "",
    icon: <FaRegHospital size={18} />,
    href: "/admin/structures",
    type: "page",
  },

  referentielPage: {
    id: "referentielPage",
    name: "Referentiel",
    description: "",
    icon: <FaListUl size={16} />,
    href: "/admin/referentiel",
    type: "page",
  },

  configurationPage: {
    id: "configurationPage",
    name: "Configuration",
    description: "",
    icon: <PiGear size={22} />,
    href: "/admin/config",
    type: "page",
  },

  patientsPage: {
    id: "patientsPage",
    name: "Dossiers",
    description: "",
    icon: <FaRegFolderOpen size={18} />,
    href: "/patients",
    type: "page",
  },

  patientPage: {
    id: "patientPage",
    name: "Mon Dossier",
    description: "",
    icon: <FaRegFolderOpen size={18} />,
    href: "/monDossier",
    type: "page",
  },

  notificationsPage: {
    id: "notificationsPage",
    name: "Notifications",
    description: "",
    icon: <TbBell size={18} />,
    href: "/notifications",
    type: "page",
  },

  waitingRoomsPage: {
    id: "waitingRoomsPage",
    name: "Salles d'attente",
    description: "",
    icon: <LuScreenShare size={18} />,
    href: "/waitingRooms",
    type: "page",
  },

  explorationsPage: {
    id: "explorationsPage",
    name: "Examens",
    // name: "Planning",
    description: "",
    icon: <GrTestDesktop size={18} />,
    href: "/explorations",
    type: "page",
  },

  hospitalisationsPage: {
    id: "hospitalisationsPage",
    name: "Hospitalisations",
    description: "",
    icon: <TbBed size={18} />,
    href: "/hospitalisations",
    type: "page",
  },

  calendarPage: {
    id: "calendarPage",
    name: "Agenda",
    description: "",
    icon: <MdOutlineCalendarMonth size={18} />,
    href: "/calendar",
    type: "page",
  },

  anapathPage: {
    id: "anapathPage",
    name: "Laboratoire",
    description: "",
    icon: <LuMicroscope size={20} />,
    href: "/laboratoire",
    type: "page",
  },

  anapathTasksPage: {
    id: "anapathTasksPage",
    name: "Tâches",
    description: "",
    icon: <LuMicroscope size={20} />,
    href: "/anapathTasks",
    type: "page",
  },

  documentsPage: {
    id: "documentsPage",
    name: "Impression",
    description: "",
    icon: <BiPrinter size={18} />,
    href: "/printingDemands",
    type: "page",
  },

  humanResourcesPage: {
    id: "humanResourcesPage",
    name: "Planning",
    description: "",
    icon: <LuCalendarCheck size={18} />,
    href: "/hr",
    type: "page",
  },
  pharmacyDashboardPage: {
    id: "pharmacyDashboardPage",
    name: "Dashboard (P)",
    description: "",
    icon: <FiPieChart size={18} />,
    href: "/pharmacie/dashboard",
    type: "page",
  },
  pharmacyServicesPage: {
    id: "pharmacyServicesPage",
    name: "Services",
    description: "",
    icon: <FaRegHospital size={18} />,
    href: "/pharmacie/services",
    type: "page",
  },
  laboratoireDashboardPage: {
    id: "laboratoireDashboardPage",
    name: "Dashboard (L)",
    description: "",
    icon: <FiPieChart size={18} />,
    href: "/laboratoire/dashboard",
    type: "page",
  },
  pharmacyCategoriesPage: {
    id: "pharmacyCategoriesPage",
    name: "Classes",
    description: "",
    icon: <FaListUl size={14} />,
    href: "/pharmacie/productCategories",
    type: "page",
  },

  pharmacyEntriesPage: {
    id: "pharmacyEntriesPage",
    name: "Entrées",
    description: "",
    icon: <LuArchive size={18} />,
    href: "/pharmacie/entries",
    type: "page",
  },
  pharmacyCommandsPage: {
    id: "pharmacyCommandsPage",
    name: "Commandes",
    description: "",
    icon: <HiOutlineDocumentAdd size={18} />,
    href: "/pharmacie/commandes",
    type: "page",
  },
  pharmacySuppliersPage: {
    id: "pharmacySuppliersPage",
    name: "Fournisseurs",
    description: "",
    icon: <FaRegBuilding size={18} />,
    href: "/pharmacie/suppliers",
    type: "page",
  },
  pharmacyBrandsPage: {
    id: "pharmacyBrandsPage",
    name: "Laboratoires",
    description: "",
    icon: <MdOutlineMedicalServices size={18} />,
    href: "/pharmacie/brands",
    type: "page",
  },
  pharmacyLocationsPage: {
    id: "pharmacyLocationsPage",
    name: "Entrepôts",
    description: "",
    icon: <GrLocation size={18} />,
    href: "/pharmacie/locations",
    type: "page",
  },
  pharmacyImputationsPage: {
    id: "pharmacyImputationsPage",
    name: "Imputations",
    description: "",
    icon: <LuArchive size={18} />,
    href: "/pharmacie/imputations",
    type: "page",
  },
  pharmacyTendersPage: {
    id: "pharmacyTendersPage",
    name: "Marchés",
    description: "",
    icon: <CgFileDocument size={18} />,
    href: "/pharmacie/tenders",
    type: "page",
  },
  pharmacyProductsPage: {
    id: "pharmacyProductsPage",
    name: "Produits",
    description: "",
    icon: <PiPillBold size={18} />,
    href: "/pharmacie/products",
    type: "page",
  },
  pharmacyRecapsPage: {
    id: "pharmacyRecapsPage",
    name: "Etats",
    description: "",
    icon: <HiOutlineDocumentSearch size={18} />,
    href: "/pharmacie/recaps",
    type: "page",
  },
  pharmacyReleasesPage: {
    id: "pharmacyReleasesPage",
    name: "Sorties",
    description: "",
    icon: <LuArchiveRestore size={18} />,
    href: "/pharmacie/releases",
    type: "page",
  },
  stocksPage: {
    id: "stocksPage",
    name: "Stocks",
    description: "",
    icon: <PiBarcodeBold size={18} />,
    href: "/pharmacie/stocks",
    type: "page",
  },

  inventoryPage: {
    id: "inventoryPage",
    name: "Inventaire",
    description: "",
    icon: <PiBarcodeBold size={18} />,
    href: "/pharmacie/inventory",
    type: "page",
  },

  accountingPage: {
    id: "accountingPage",
    name: "Comptabilité",
    description: "",
    icon: <TbDatabaseDollar size={18} />,
    href: "/accounting",
    type: "page",
  },

  feedPage: {
    id: "feedPage",
    name: "Echanges",
    description: "",
    icon: <MdDynamicFeed size={18} />,
    href: "/feed",
    type: "page",
  },

  messageriePage: {
    id: "messageriePage",
    name: "Messagerie",
    description: "",
    icon: <RiMessage2Line size={18} />,
    href: "/messagerie",
    type: "page",
  },

  profilePage: {
    id: "profilePage",
    name: "Mon Profil",
    description: "",
    icon: <CgProfile size={18} />,
    href: "/profile",
    type: "page",
  },

  serverPollsPage: {
    id: "serverPollsPage",
    name: "Server Statuses",
    description: "",
    icon: <FiPieChart size={18} />,
    href: "/admin/serverPolls",
    type: "page",
  },
  ticketsPage: {
    id: "ticketsPage",
    name: "Problèmes",
    description: "",
    icon: <FiPieChart size={18} />,
    href: "/tickets",
    type: "page",
  },

  medLegDashboardPage: {
    id: "medLegDashboardPage",
    name: "Dashboard (ML)",
    description: "",
    icon: <FiPieChart size={18} />,
    href: "/medLegDashboard",
    type: "page",
  },
  ecgDashboardPage: {
    id: "ecgDashboardPage",
    name: "Dashboard",
    description: "",
    icon: <FiPieChart size={18} />,
    href: "/ecgs",
    type: "page",
  },

  ecgsPage: {
    id: "ecgsPage",
    name: "ECGs",
    description: "",
    icon: <FaRegFolderOpen size={18} />,
    href: "/ecgs",
    type: "page",
  },

  ecgUsersPage: {
    id: "ecgUsersPage",
    name: "Utilisateurs",
    description: "",
    icon: <FiUsers size={18} />,
    href: "/ecgUsers",
    type: "page",
  },

  ecgProfilePage: {
    id: "ecgProfilePage",
    name: "Profil",
    description: "",
    icon: <CgProfile size={18} />,
    href: "/ecgProfile",
    type: "page",
  },

  nurseView: {
    id: "nurseView",
    name: "Visualiser une hospitalisation en tant qu'infirmier",
    description:
      "Voir certaines informations seulement au lieu de la vue complète du médecin",
    type: "action",
  },

  antecedents: {
    id: "antecedents",
    name: "Visualiser antécédents",
    description: "Permet de visualiser les antécédents des patients",
    type: "action",
  },

  admissionDocuments: {
    id: "admissionDocuments",
    name: "Documents Admission",
    description: "Permet de visualiser les documents d'admission",
    type: "action",
  },

  openWaitingRoomAppointment: {
    id: "openWaitingRoomAppointment",
    name: "Ouvrir un rendez-vous en salle d'attente",
    description: "Permet d'ouvrir un rendez-vous en salle d'attente",
    type: "action",
  },

  ecrfDashboardPage: {
    id: "ecrfDashboardPage",
    name: "Dashboard",
    description: "",
    icon: <FiPieChart size={18} />,
    href: "/ecrf/dashboard",
    type: "page",
  },

  ecrfFichesPage: {
    id: "ecrfFichesPage",
    name: "Fiches",
    description: "",
    icon: <LuFolderCheck size={18} />,
    href: "/ecrf/fiches",
    type: "page",
  },

  ecrfValidationPage: {
    id: "ecrfValidationPage",
    name: "Validation",
    description: "",
    icon: <MdContentPasteSearch size={19} />,
    href: "/ecrf/validation",
    type: "page",
  },

  ecrfUsersPage: {
    id: "ecrfUsersPage",
    name: "Utilisateurs",
    description: "",

    icon: <FiUsers size={18} />,
    href: "/ecrf/utilisateurs",
    type: "page",
  },

  ecrfForms: {
    id: "ecrfForms",
    name: "Questionnaires",
    description: "",
    icon: <FaListUl size={16} />,
    href: "/ecrf/questionnaires",
    type: "page",
  },
  loginPage: {
    id: "loginPage",
    name: "Déconnexion",
    description: "",
    icon: <MdLogout size={18} />,
    href: "/login",
    type: "page",
  },
};
